import { useEffect } from 'react';
import { Link } from 'react-router';
import { AppMark, APP_NAME } from '../components/shell/AppMark.js';
import { HowItWorksPage } from './HowItWorksPage.js';

/**
 * Spec 247 — the tour, reachable signed out.
 *
 * Kridt: "How it works" is linked from the sign-in sheet. The in-app page sits
 * inside the authenticated shell, so from the sheet it would 401 straight back
 * to the sheet. This renders the SAME page component — one tour, not two that
 * drift — in a minimal frame outside the auth providers. It makes no protected
 * request: the tour is static, and its one optional read of the selected brand
 * goes through `useOptionalBrand`, which returns null out here.
 */
export function PublicHowItWorksPage() {
  useEffect(() => {
    document.title = `How it works — ${APP_NAME}`;
  }, []);

  return (
    <div className="min-h-dvh bg-[var(--hub-color-ground)]" data-testid="public-how-it-works">
      <header className="hub-shell__brand bg-[var(--hub-color-surface)]">
        <AppMark />
        {APP_NAME}
        <Link to="/signin" className="hub-btn hub-btn--ghost ml-auto" data-testid="public-how-it-works-signin">
          Sign in
        </Link>
      </header>
      <HowItWorksPage />
    </div>
  );
}
